import React, { FC } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { up } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import Spacer from '../../Spacer';
import RichText from '../../RichText';
import { HeaderProps } from '../Header';
import * as S from './StandardHeader-styled';
import BodyText from '../../BodyText';
import Button from '../../Button';

const StandardHeader: FC<HeaderProps> = ({
  title,
  subtitle,
  paragraph,
  desktopImage,
  buttonColor,
  buttonContent,
  buttonLink,
}) => {
  const isTabletUp = useBreakpoint(up('tablet-portrait'));

  const style = isTabletUp ? '.desktop-riadus' : '.mobile-radius';
  
  return (
    <S.Container>
      <S.SubContainer>
        <S.ImageContainer>
          <GatsbyImage
            image={desktopImage?.gatsbyImageData}
            alt=""
            imgClassName={style}
          />
        </S.ImageContainer>
        {isTabletUp && (
          <BodyText
            textSize={[null, null, 'f1', 'f2']}
            css={`
              position: absolute;
              width: fit-content;
              transform: rotate(270deg);
              bottom: 1.625rem;
              left: -1.9rem;
            `}
          >
            KAMUSTA
          </BodyText>
        )}
      </S.SubContainer>
      {!isTabletUp && <Spacer spacing="md3" />}
      <S.MetaContainer>
        <RichText document={title.richText} />
        {subtitle && (
          <>
            <Spacer spacing="md1" />
            <RichText
              document={subtitle?.richText}
              textSize="f3"
              fontFamily="helvetica"
            />
          </>
        )}
        {paragraph && (
          <>
            <Spacer spacing="sm2" />
            <RichText
              document={paragraph?.richText}
              textSize="f3"
              fontFamily="helvetica"
            />
          </>
        )}
        {buttonLink && buttonContent && (
          <>
            <Spacer spacing="md4" />
            <Button
              type={buttonLink?.link_type}
              url={buttonLink?.url ?? ''}
              color={isTabletUp ? buttonColor ?? 'navy' : 'navy'}
            >
              {buttonContent}
            </Button>
          </>
        )}
      </S.MetaContainer>
    </S.Container>
  )
};

export default StandardHeader;
